import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default () => {
    const nodeSelectors = {
        projectSlider: '[js-project-slider="slider"]',
        prevButton: '[js-project-slider="prev"]',
        nextButton: '[js-project-slider="next"]',
        sliderCounter: '[js-project-slider="counter"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.projectSlider)) {
            return
        }

        initProjectSlider()
    }

    function initProjectSlider() {
        const projectSlider = new Swiper(nodeSelectors.projectSlider, {
            modules: [Pagination, Navigation],
            slidesPerView: 1,
            navigation: {
                nextEl: nodeSelectors.nextButton,
                prevEl: nodeSelectors.prevButton,
            },
            on: {
                init: function () {
                    const index_currentSlide = this.realIndex + 1;
                    //
                    $(nodeSelectors.sliderCounter).text(index_currentSlide)
                },
                slideChangeTransitionEnd: function () {
                  const index_currentSlide = this.realIndex + 1;
                  //
                  $(nodeSelectors.sliderCounter).text(index_currentSlide)
                  
                },
            },
        });
    }

    return Object.freeze({
        init,
    })
}